<template>
    <steps-option
        @updateNavigation="updateNavigation"
        :disable-accordions="true"
    />
</template>

<script>
    import StepsOption from './StepsOption.vue';

    export default {
        components: {
            StepsOption,
        },

        methods: {
            updateNavigation(navRules) {
                this.$emit('updateNavigation', navRules);
            },
        },
    };
</script>
